export default "__VITE_ASSET__VXl6wk5W__"